<template>
    <!-- 手写签名组件 -->
      <div >
        <div >
          <div id="signWrap" :style="{'width':width , 'height':height}">
            <canvas :id="canvasName" width="100%" height="100%" />
          </div>
        </div>
      </div>
</template>

<script>
export default {
  props: {
      //名称
      canvasName: {
          require: true,
          type: String,
          default:'myCanvas'
      },
      width: {
          type: String,
          default: '100%'
      },
      height: {
          type:String,
          default: '100%'
      },
      img: {
          type:String,
          default: ''
      },
  },
  data() {
    return {
        image: '',
        mousePressed: false,
        c: '',
        ctx: '',
        lastX: 0,
        lastY: 0
    }
  },
  mounted() {

      this.image = ''
      this.mousePressed = false
      // var lastX, lastY
      this.ctx = document.getElementById(this.canvasName).getContext('2d')
      this.c = document.getElementById(this.canvasName)
      var signWrap = document.getElementById('signWrap')
      this.c.width = signWrap.clientWidth // 设置宽度
      this.c.height = signWrap.clientHeight // 设置高度
      // 监听touchstart事件，touchmove事件，touchend事件等事件
      this.InitThis()
  },
  methods: {
      InitThis() {
          // 触摸屏
          var that = this
          this.c.addEventListener(
              'touchstart',
              function (event) {
                console.log('触摸');

                  if (event.targetTouches.length === 1) {
                      event.preventDefault() // 阻止浏览器默认事件，重要
                      var touch = event.targetTouches[0]
                      console.log('pageY', touch.pageY );
                      console.log('offsetTop',this.offsetTop);
                      this.mousePressed = true
                      that.Draw(
                          touch.pageX -  this.getBoundingClientRect().left,
                          touch.pageY - this.getBoundingClientRect().top  ,
                          false
                      )
                  }
              },
              false
          )
          this.c.addEventListener(
              'touchmove',
              function (event) {
                     console.log('触摸结束');
                  if (event.targetTouches.length === 1) {
                      event.preventDefault() // 阻止浏览器默认事件，重要
                      var touch = event.targetTouches[0]
                      if (this.mousePressed) {
                          that.Draw(
                              touch.pageX -  this.getBoundingClientRect().left,
                              touch.pageY -  this.getBoundingClientRect().top  ,
                              true
                          )
                      }
                  }
              },
              false
          )
          this.c.addEventListener(
              'touchend',
              function (event) {
                  if (event.targetTouches.length === 1) {
                      event.preventDefault() // 阻止浏览器默认事件，防止手写的时候拖动屏幕，重要
                      this.mousePressed = false
                  }
              },
              false
          )
          // 鼠标
          this.c.onmousedown = function (event) {
            console.log(123);
              this.mousePressed = true
              console.log('x',event.pageX)
              console.log('y',event.pageY )
              console.log('fx', this.getBoundingClientRect().left)
              console.log('fy',this.offsetTop)
              that.Draw(
                  event.pageX -  this.getBoundingClientRect().left,
                  event.pageY - this.getBoundingClientRect().top,
                  false
              )
          }
          this.c.onmousemove = function (event) {

              if (this.mousePressed) {
                  that.Draw(
                      event.pageX -  this.getBoundingClientRect().left,
                      event.pageY - this.getBoundingClientRect().top,
                      true
                  )
              }
          }
          this.c.onmouseup = function (event) {
            console.log(123123);
              this.mousePressed = false
          }
      },
      Draw(x, y, isDown) {
          console.log(x, y)

          if (isDown) {
              this.ctx.beginPath()
              this.ctx.strokeStyle = '#000' // 颜色
              this.ctx.lineWidth = 3 // 线宽
              this.ctx.lineJoin = 'round'
              this.ctx.lineMax = 10 // 设置画笔最大线宽
              this.ctx.lineMin = 3 // 设置画笔最小线宽
              this.ctx.linePressure = 1.2 // 设置画笔笔触压力
              this.ctx.smoothness = 30 // 设置画笔笔触大小变化的平滑度
              this.ctx.moveTo(this.lastX, this.lastY)
              this.ctx.lineTo(x, y)
              this.ctx.closePath()
              this.ctx.stroke()
          }
          this.lastX = x
          this.lastY = y
      },
      // 清空画板
      clearArea() {
          this.ctx.setTransform(1, 0, 0, 1, 0, 0)
          this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)
          this.$emit('update:img', '');
      },
      // 提交签名
      saveSign() {
          this.checkEmpty() // 调用 表单非空验证
      },
      checkEmpty() {
          var c = document.getElementById(this.canvasName) // 获取html的canvas对象，我这个id="myCanvas"
          if (this.isCanvasBlank(c)) {
              console.log('请在签名区域签名后再次确认')
              return
          } else {
              var image = this.c.toDataURL('image/png') // 得到生成后的签名base64位  url 地址
              this.$emit('update:img', image); // 打印图片base64 url
          }
      },
      // 验证canvas画布是否为空函数
      isCanvasBlank(canvas) {
          var blank = document.createElement('canvas') // 系统获取一个空canvas对象
          blank.width = canvas.width
          blank.height = canvas.height
          return canvas.toDataURL() === blank.toDataURL() // 比较值相等则为空
      },
      //base64转文件
      base64toFile(dataurl, filename = 'file') {
          let arr = dataurl.split(',');
          let mime = arr[0].match(/:(.*?);/)[1];
          let suffix = mime.split('/')[1];
          let bstr = atob(arr[1]);
          let n = bstr.length;
          let u8arr = new Uint8Array(n);
          while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], `${filename}.${suffix}`, {
              type: mime
          });
      }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/assessment/signature.vue